<template>
  <span v-if="task.discarded" >
    <i class="material-icons pointer" @click="restoreTask(task)">settings_backup_restore</i>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    restoreTask(task){
      this.$parent.$parent.restoreTask(task);
    }
  }
}
</script>
